import { useState, useEffect } from 'react'
import { Dialog, DialogPanel, DialogTitle, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import { CalendarDaysIcon, CreditCardIcon, UserCircleIcon } from '@heroicons/react/20/solid'

export default function Wide({...props}) {
  const [open, setOpen] = useState(true)
  useEffect(() => {
    return () => {

    };
  }, [props.data.id, open]);

    const closePanel =(event) => {
        if(event?.type == 'keydown' && event?.key != 'Escape') return;
        if(props.onCloseHandler) {
           props.onCloseHandler(event); 
        }
        
        
        setOpen(false);
        //props.onClose();
    }
    
useEffect( () => document.addEventListener("keydown", closePanel), [ props.data ] );    
useEffect( () => () => document.removeEventListener("keydown", closePanel), [props.data] );
    
  return (

      <div className="inset-0 overflow-hidden">
        <div className=" inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16 z-10" >
          
          
                     <div
              className={"pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out "
              + ((open) ? "" : "translate-x-full")
              }
              data-closed
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                <div className="px-4 py-6 sm:px-6">
                  <div className="flex items-start justify-between">
                    <div className="text-base font-semibold leading-6 text-gray-900">Detail: {props.headerTxt}</div>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => closePanel()}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                      </button>
                    </div>
                  </div>
                </div>
                
                {props.children}          
                
                </div>
                </div>
          
          
          
          
          
          </div>
        </div>
        </div>
        
        )
}        